/* eslint-disable react/button-has-type */

/* eslint-disable react/prop-types */
import React from "react";

import styled from "styled-components";

import Markdown from "../../styles/Markdown";

const StyledButtonGroup = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  margin-top: 24px;
`;

const StyledArrowButton = styled.button`
  background: ${(props) => (props.isCustom ? "transparent" : "#f3f4f6")};
  border: none;
  padding: ${(props) => (props.isCustom ? "0" : "12px")};
  border-radius: 9999px;
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background: ${(props) => (props.isCustom ? "transparent" : "#e5e7eb")};
  }
`;

export function CustomRightArrow({ onClick, arrowSize, arrowColor }) {
  return (
    <button
      onClick={onClick}
      aria-label="Next slide"
      className="react-multiple-carousel__arrow react-multiple-carousel__arrow--right"
      style={{
        position: "absolute",
        right: "10px",
        zIndex: 1,
        border: "none",
        background: "rgba(0,0,0,0.5)",
        borderRadius: "50%",
        width: `${arrowSize + 16}px`,
        height: `${arrowSize + 16}px`,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
      }}
    >
      <svg
        width={arrowSize}
        height={arrowSize}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9 18L15 12L9 6"
          stroke={arrowColor}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </button>
  );
}

export function CustomLeftArrow({ onClick, arrowSize, arrowColor }) {
  return (
    <button
      onClick={onClick}
      aria-label="Previous slide"
      className="react-multiple-carousel__arrow react-multiple-carousel__arrow--left"
      style={{
        position: "absolute",
        left: "10px",
        zIndex: 1,
        border: "none",
        background: "rgba(0,0,0,0.5)",
        borderRadius: "50%",
        width: `${arrowSize + 16}px`,
        height: `${arrowSize + 16}px`,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
      }}
    >
      <svg
        width={arrowSize}
        height={arrowSize}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15 18L9 12L15 6"
          stroke={arrowColor}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </button>
  );
}

export function CarouselArrows({
  next,
  previous,
  leftArrowContent,
  rightArrowContent,
}) {
  if (leftArrowContent || rightArrowContent) {
    return (
      <StyledButtonGroup>
        {leftArrowContent && (
          <StyledArrowButton
            isCustom
            onClick={() => previous()}
            aria-label="Previous slide"
          >
            <Markdown>{leftArrowContent}</Markdown>
          </StyledArrowButton>
        )}
        {rightArrowContent && (
          <StyledArrowButton
            isCustom
            onClick={() => next()}
            aria-label="Next slide"
          >
            <Markdown>{rightArrowContent}</Markdown>
          </StyledArrowButton>
        )}
      </StyledButtonGroup>
    );
  }

  return (
    <StyledButtonGroup>
      <StyledArrowButton onClick={() => previous()} aria-label="Previous slide">
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15 18L9 12L15 6"
            stroke="#374151"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </StyledArrowButton>
      <StyledArrowButton onClick={() => next()} aria-label="Next slide">
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9 18L15 12L9 6"
            stroke="#374151"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </StyledArrowButton>
    </StyledButtonGroup>
  );
}
